import Artist from './Artist';
const MyArtistPage = () => {
  return <Artist useCase="byUser" />;
};
export default MyArtistPage;
